export default {
  en_US: 'en_US',
  zh_CN: 'zh_CN',
};
